import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import DyCollectionCard from '../DyCollectionCard/DyCollectionCard';

import useDyRecommendationWidgetData from '../../hooks/useDyRecommendationWidget';

import { StyledWrapper, StyledH5 } from './DySliderStyles';

var DySlider = function DySlider(props) {
  var dyData = useDyRecommendationWidgetData({
    dySlug: props.dySlug,
    sizeOption: props.sizeOption,
    maxItems: 16
  });

  var slidesToScroll = props.sidebar ? 2 : 4;

  var infinite = dyData.items.length > slidesToScroll ? true : false; // if one item, turn off infinite loop

  // Temp to hide new products (until May 1)
  var items = dyData.items.filter(function (item) {
    return !item.item.tags.includes('BacktoSchool2020');
  });
  // end of temp. Remove and add commented code below

  var responsive = props.sidebar ? null : [{
    breakpoint: 1000,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 500,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }];

  // Change back to dyData.items after May 1 launch
  if (dyData.items.length > 0) {
    return React.createElement(
      StyledWrapper,
      {
        className: 'dy-slider-wrapper ' + props.dySlug,
        widgetName: props.sliderId || props.dySlug,
        'data-dy-widget-id': dyData.widgetId,
        'data-dy-strategy-id': dyData.strategy,
        'data-dy-feed-id': dyData.feedId
      },
      React.createElement(
        StyledH5,
        { widgetName: props.sliderId || props.dySlug },
        dyData.title
      ),
      React.createElement(
        Slider,
        {
          infinite: infinite,
          slidesToShow: slidesToScroll,
          rows: 1,
          slidesToScroll: slidesToScroll,
          dots: true,
          responsive: responsive
        },
        dyData.items.map(function (item) {
          return React.createElement(DyCollectionCard, {
            key: item.item.sku,
            product: item.item,
            addVariantToCart: props.addVariantToCart,
            checkout: props.checkout
          });
        })
      )
    );
  } else {
    return null;
  }
};

DySlider.propTypes = {
  sidebar: PropTypes.bool,
  dySlug: PropTypes.string.isRequired,
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  sliderId: PropTypes.string,
  sizeOption: PropTypes.string
};

export default React.memo(DySlider);